import React, {useState} from "react";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import Popover from "@material-ui/core/Popover";
import Paper from "@material-ui/core/Paper";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";

import Button from "./CustomButtons/Button.jsx";
import customDropdownStyle from "assets/jss/material-dashboard-pro-react/components/customDropdownStyle.jsx";

/**
 * Botão que abre um popover para escolher entre várias opções.
 *
 * Opções falsas (`condicao && {...}`) são ignoradas, e quando sobra só uma o clique executa-a
 * logo, sem popover — é o que permite mostrar as escolhas apenas a certos perfis.
 */
const BotaoOpcoes = (props) => {
  const {classes, className, disabled, style, children, opcoes} = props;
  const [popover, setPopover] = useState(null);

  const disponiveis = opcoes.filter(Boolean);

  return <>
    <Button
      className={className}
      disabled={disabled}
      style={style}
      onClick={(e) => disponiveis.length === 1 ? disponiveis[0].onClick() : setPopover(e.currentTarget)}
    >
      {children}
    </Button>
    <Popover
      open={!!popover}
      anchorEl={popover}
      onClose={() => setPopover(null)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: -10,
        horizontal: 'center',
      }}>
      <Paper className={classes.dropdown}>
        <MenuList role="menu" className={classes.menuList}>
          {disponiveis.map((opcao, i) => <MenuItem key={i} onClick={() => {
            setPopover(null);
            opcao.onClick();
          }}>
            {opcao.texto}
          </MenuItem>)}
        </MenuList>
      </Paper>
    </Popover>
  </>;
};

BotaoOpcoes.propTypes = {
  classes: PropTypes.object.isRequired,
  /** Opções do popover: {texto, onClick}. Entradas falsas são ignoradas */
  opcoes: PropTypes.array.isRequired,
  /** Conteúdo do botão (ícone + texto) */
  children: PropTypes.node,
  /** Classes do botão, dadas pela página (p.e. addStuffButton + button + primary) */
  className: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object
};

export default withStyles(customDropdownStyle)(BotaoOpcoes);
